module.exports = __webpack_public_path__ + "static/img/1.6505d2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/1.png
// module id = HJ6R
// module chunks = 0